<template>
  <div class="how_step article">
    <div class="row">

      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_icon_p">
        <img class="install_img"
          :src="app_root + '/assets/common/img/install_photoplus.png'"
        />
      </div>

      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <p class="app_title">
          <LabelFunMessage fcontId="0" msgkey="85" />
        </p>

        <p class="indent_caption">
          <slot></slot>
        </p>

        <p>
          <!-- 詳細および対応プリンターはこちらをご覧ください。 -->
          <LabelFunMessage fcontId="0" msgkey="137" />
        </p>

        <p>
            <a
              class="btn btn-info btn-lg btn-download"
              v-on:click="trackGa4AppDownloadEvent()"
              href="https://www.epson.jp/products/colorio/guide/software/"
              target="_blank"
              rel="noopener"
            >
            <LabelFunMessage fcontId="0" msgkey="161" />&nbsp;&raquo;
            </a>
          </p>
      </div>

      <!-- <div class="col-sm-6 col-md-6 col-lg-6">
        <img :src="app_root + '/assets/common/img/photoplus_jp.jpg'" class="img-responsive center-block">
      </div> -->

      <!--/col-->
    </div>
    <!--/row-->
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "AppDownloadPhotoPlusJp",
  components: {
    LabelFunMessage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1);
    },
  },
  methods: {
    trackGa4AppDownloadEvent: function () {
      this.$gtag.event("app_download", {
        app_name: "Photo Plus",
        location_id: "article",
        article_no: this.fcontId,
        site_id: "gallery"
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.install_img {
  padding: 0px;
}
</style>